import React, { FC } from 'react';
import CompanyList from '@components/search/companyList';
import useCompanyList from '@components/search/query/useCompanyList';

import TextFormat from '@utils/text/format';
import classnames from 'classnames/bind';
import styles from './searchPage.module.scss';
const cx = classnames.bind(styles);

interface ICompanyListAreaProps {
  keyword: string;
}

const CompanyListArea: FC<ICompanyListAreaProps> = ({ keyword }) => {
  const viewKeyword = TextFormat.formatEllipsis(keyword, 16);
  const { data } = useCompanyList(keyword);

  if (!data?.length) return null;

  return (
    <div className={cx('companyListArea')}>
      <strong className={cx('title')}>
        {viewKeyword}에 대한 {data.length}개의 기업 검색 결과입니다.
      </strong>
      <CompanyList companyList={data} />
    </div>
  );
};

export default CompanyListArea;
